import React from 'react';

export default data => <pre>{JSON.stringify(data, null, 2)}</pre>;
